import React from 'react'
import Grid from '@mui/material/Grid'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'

const AirwayManagement = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <Autocomplete
      multiple
      freeSolo
      options={[
        'OPA (Oropharyngeal Airway)',
        'NPA (Nasopharyngeal Airway)',
        'Endotracheal Tube',
        'Bag-Valve Mask',
        'Supraglottic Airway',
        'Surgical Airway',
        'Needle Cricothyroidotomy'
      ]}
      label="Airway Management"
      value={moduleValues?.['Airway Management'] ?? []}
      onChange={(e, value) =>
        setModuleValues((prev) => ({
          ...prev,
          ['Airway Management']: value,
        }))
      }
      renderInput={(params) => (
        <TextField {...params} fullWidth label="Airway Management" />
      )}
    />
  </Grid>
)

export default AirwayManagement
